// extracted by mini-css-extract-plugin
export var cartContainer = "_qg-4";
export var gray = "_qg-1";
export var itemContainer = "_qg-2";
export var itemDetails = "_qg-3";
export var strong = "_qg-0";